export default "__VITE_ASSET__33587bc5__"